import crypto from "crypto-js";
import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Chartcontext from "../../Context/Chartcontext";
import CommentContext from "../../Context/CommentContext/CommentContext";
import { useConfirmTabClose } from "../../hooks/useConfirmTabClose.js";
import {
  // getChartDetails,
  // getMasterData,
  saveChartInfo,
} from "../../services/chartService";
import role from "../../utils/role";
import AuthContext from "../Auth/Middleware/AuthContext";
import AuditInformation from "./AuditInformation";
import validate from "./ChartFormValidationRules";
import ChartInfo from "./ChartInfo";
import { chartStatusConstants } from "../../utils/constants";
import configurationAPI from "../../apis/configuration/configurationAPI.js";

const ChartForm = ({
  enabled,
  clientData,
  onReRenderChart,
  onReRenderTimer,
}) => {
  const data = useContext(Chartcontext);
  const auth = useContext(AuthContext);
  const [btnDisable, setBtnDisable] = useState(false);
  const { id } = useParams();
  const [isTouched, setIsTouched] = useState(false);
  const [isMangerSubmit, setIsManagerSubmit] = useState(false);
  const [chartInfoCustomFieldOnChangeData, setChartInfoCustomFieldOnChangeData] = useState({});
  const [customFieldsError, setCustomFieldsError] = useState([]);
  const [customFieldIdsForValidation, setCustomFieldIdsForValidation] = useState([]);
  const [specialCharCustomFieldIds, setSpecialCharCustomFieldIds] = useState([]);
  const strRegexSpecialCharCustomField = new RegExp(/^[0-9\.,_\-!@#$%^&*()_+=\[\]{};':"\\|,.<>\/?]*$/);

  // const [masterData, setMasterData] = useState({});
  const masterData = data?.masterData;
  const [configureField, setConfigureField] = useState(null);
  useConfirmTabClose(isTouched);
  onReRenderTimer(false);

  const {
    defaultAudit,
    defaultHold,
    defaultResponsible,
    defaultChartStatus,
    defaultDisposition,
    defaultSubSpecialty,
    // setchartstatus,
    // setDisposition,
    defaultPrimaryHealth,
    defaultFacility,
    setDefaultAudit,
    setDefaultHold,
    setDefaultResponsible,
    setDefaultChartStatus,
    setDefaultDisposition,
    // setDefaultFacility,
    // setDefaultPrimaryHealth,
    allocateAuditor,
    defaultQC,
    priority,
  } = useContext(Chartcontext);

  const {
    commentInpval,
    errorsForChat,
    setErrorsForChat,
    commentedInCommentLog,
    errorsFromAuditorToChart,
  } = useContext(CommentContext);

  // useEffect(() => {
  //   setIsTouched(true);
  // }, [
  //   defaultDisposition,
  //   defaultChartStatus,
  //   defaultResponsible,
  //   defaultHold,
  //   defaultAudit,
  // ]);

  const handleDateTimeChange = (dates, dateStr, instance) => {
    setIsTouched(true);
    data.setInputval(() => {
      return {
        ...data.inpval,
        [instance.input.name]: instance.input.value,
      };
    });
  };

  useEffect(() => {
    if (commentInpval) {
      commentInpval.comment_msg = null;
    }

    if (allocateAuditor) {
      allocateAuditor.value = clientData?.next_user?.id;
      allocateAuditor.label = clientData?.next_user?.name;
    }
    // getChartDetails(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled]);

 const filterAndDeduplicateConfiguration = (configData, clientSpecialtyId) => {

   const filteredData = configData?.filter(
     item => item.SpecialtyId === clientSpecialtyId || item.SpecialtyId === 0
   );
 
   const deduplicatedData = filteredData?.reduce((acc, current) => {
     const existing = acc?.find(item => item.field === current.field);
 
     if (existing) {
       if (current.SpecialtyId !== 0) {
         return acc?.map(item => (item.field === current.field ? current : item));
       }
     } else {
       acc.push(current);
     }
 
     return acc;
   }, []);
 
   return deduplicatedData;
 };
 
 const fetchConfigurationData = async () => {
  const configResponse = await configurationAPI.getConfiguration(0, clientData?.LocationId);

  const filteredConfigData = filterAndDeduplicateConfiguration(
   configResponse?.chartFieldConfiguration,
   clientData.SpecialtyId
 );

   setConfigureField(filteredConfigData);
   
};

  // const fetchMasterData = () => {
  //   getMasterData()
  //     .then((response) => {
  //       setMasterData(response?.data);
  //       setDisposition(response?.data?.dispositions);
  //       setchartstatus(response?.data?.statuses);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // };

  useEffect(() => {
    // fetchMasterData();
    if(clientData?.LocationId) {
      fetchConfigurationData();
    }
    setDefaultAudit(data?.AuditOptions);
    setDefaultResponsible(data?.ResponsibleParties);
    setDefaultHold(data?.HoldReasons);
    setDefaultChartStatus({ label: data?.Status, value: data?.StatusId });
    setDefaultDisposition({
      label: data?.UserLastName,
      value: data?.DispositionId,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const validateNewCustomFields = () => {
    let isValid = true;
    console.log(chartInfoCustomFieldOnChangeData)
    for (const key of customFieldIdsForValidation){
      if (!chartInfoCustomFieldOnChangeData[key] || (Array.isArray(chartInfoCustomFieldOnChangeData[key]) && chartInfoCustomFieldOnChangeData[key].length === 0)) {
        setCustomFieldsError(prev => ({...prev, [key]: 'Required'}))
        isValid = false;
      } else {
        isValid = true;
        setCustomFieldsError(prev => ({...prev, [key]: ''}))
      }
    }

    // special character validation for custom fields where isSpecialCharAllowed is true
    for (const fieldId of specialCharCustomFieldIds) {
      const val = chartInfoCustomFieldOnChangeData[fieldId];
      if (val) {
        const result = strRegexSpecialCharCustomField.test(val);
        if (!result) {
          setCustomFieldsError(prev => ({ ...prev, [fieldId]: 'Only numbers and special characters allowed. Letters and spaces are not permitted.' }));
          isValid = false;
        }
      }
    }

    return isValid;
  };


  const submitChart = async (e) => {
    e.preventDefault();
    if (btnDisable) return;
    setBtnDisable(true);

    // if (
    //   auth.role === role?.Coder ||
    //   auth.role === role?.Manager ||
    //   auth.role === role?.TeamLead
    // ) {
    //   getChartDetails(id);
    // }

    try {

      if (data.inpval.StatusId === chartStatusConstants.INCOMPLETE_STATUS_ID) {
        data.inpval.date_of_completion = "";
      }
      let obj = data.inpval;
      obj = {
        ...obj,
        HoldReasons: defaultHold?.map((item) => item?.value),
        DispositionId: defaultDisposition?.value ?? clientData?.DispositionId,
        FacilityId: defaultFacility?.value ?? clientData?.FacilityId,
        PrimaryHealthId: defaultPrimaryHealth?.value ?? clientData?.PrimaryHealthId,
        SubSpecialtyId: defaultSubSpecialty?.value,
        Priority: priority?.value,
        ResponsibleParties: defaultResponsible?.map((item) => item?.value) ?? clientData?.ResponsibleParties?.map((item) => item.value),
        StatusId: defaultChartStatus?.value,
        QCStatusId: defaultQC?.value ?? null,
        AuditOptions: defaultAudit?.map((item) => item?.value),
        next_user_id:
          allocateAuditor?.value !== "" ? allocateAuditor?.value ?? null : null,
        comment_msg:
          commentedInCommentLog === true ? commentInpval?.comment_msg : null,
      };
      let boolValid = false;

      if ( auth.role === role?.Coder || auth.role === role?.Manager || auth.role === role?.TeamLead ) {
        boolValid = await validateSchema(obj, clientData);
        const isValid = validateNewCustomFields();
        if (!isValid) {
          return;
        }
        obj.chartInfoCustomFields = {};
        Object.entries(chartInfoCustomFieldOnChangeData)?.forEach(([key, value]) => {
          obj.chartInfoCustomFields[key] = value;
        });
      }

      if (!boolValid) return;
      setErrorsForChat({});
      
      const res = await saveChartInfo(id, obj, errorsForChat, clientData);
      if (res === true) {
        setIsTouched(false);
        handleReRenderChart();
        return;
      }
    } catch (error) {
      console.log(error);
    }
    finally {
      setBtnDisable(false);
    }
  };

  const validateSchema = async (obj, clientData) => {
    const response = await validate(obj, clientData, masterData, configureField);
    if (Object.keys(response).length === 0) {
      return true;
    } else {
      setErrorsForChat(response);
      return false;
    }
  };

  const getdata = (e) => {
    setIsTouched(true);
    const { value, name } = e.target;

    data.setInputval(() => {
      return {
        ...data.inpval,
        [name]: value,
      };
    });
  };

  const getmr_no = (e) => {
    setIsTouched(true);
    const { value } = e.target;
    data.setInputval(() => {
      return {
        ...data.inpval,
        mr_no: crypto.AES.encrypt(
          value,
          process.env.REACT_APP_SECRET_PASS,
        ).toString(),
      };
    });
  };

  const handleSelectChange = (event) => {
    setIsTouched(true);
    const selectedId = parseInt(event.target.value);
    const { name } = event.target;
    data.setInputval(() => {
      return {
        ...data.inpval,
        [name]: selectedId,
      };
    });
  };

  const handleKeypress = (e) => {
    if (e.keyCode === 8) {
      setIsTouched(true);
      const { value, name } = e.target;

      data.setInputval(() => {
        return {
          ...data.inpval,
          [name]: value,
        };
      });
    }
  };

  const handleKeypressMR = (e) => {
    if (e.keyCode === 8) {
      setIsTouched(true);
      const { value } = e.target;
      data.setInputval(() => {
        return {
          ...data.inpval,
          mr_no: crypto.AES.encrypt(
            value,
            process.env.REACT_APP_SECRET_PASS,
          ).toString(),
        };
      });
    }
  };

  useEffect(() => {}, [
    defaultChartStatus,
    defaultDisposition,
    defaultHold,
    defaultAudit,
    defaultResponsible,
    defaultAudit,
    data.inpval,
    errorsForChat,
    clientData,
  ]);

  const handleReRenderChart = () => {
    onReRenderChart(true);
  };

  const handleManagerSubmit = (value) => {
    setIsManagerSubmit(value);
  };

  return (
    <>
      <div className="col-xl-12">
        <div className="flex-lg-row-fluid">
          <ul className="nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-4 fw-semibold mb-1 mb-1 ms-10">
            <li className="nav-item"></li>
          </ul>
          <div className="tab-content chart-details-tabs" id="myTabContent">
            <div
              className="tab-pane fade show active"
              id="kt_user_view_basic_tab"
              role="tabpanel"
            >
              <ChartInfo
                configureField={configureField}
                setIsTouched={setIsTouched}
                masterData={masterData}
                mainData={data}
                errorsForChat={errorsForChat}
                clientData={clientData}
                getmr_no={getmr_no}
                getdata={getdata}
                handleKeypressMR={handleKeypressMR}
                handleKeypress={handleKeypress}
                enabled={
                  enabled &&
                  (auth.role === role?.Coder ||
                    auth.role === role?.Auditor ||
                    auth.role === role?.Manager ||
                    auth.role === role?.TeamLead)
                }
                data={Object.assign(clientData, data)}
                handleDateTimeChange={handleDateTimeChange}
                handleSelectChange={handleSelectChange}
                errorsFromAuditorToChart={errorsFromAuditorToChart}
                btnDisable={btnDisable}
                chartInfoCustomFieldOnChangeData={chartInfoCustomFieldOnChangeData}
                setChartInfoCustomFieldOnChangeData={setChartInfoCustomFieldOnChangeData}
                customFieldsError={customFieldsError}
                setCustomFieldIdsForValidation={setCustomFieldIdsForValidation}
                setSpecialCharCustomFieldIds={setSpecialCharCustomFieldIds}
              />
              <AuditInformation
              configureField={configureField}
                enabled={
                  enabled &&
                  (auth.role === role.Auditor ||
                    auth.role === role.Manager ||
                    auth.role === role?.TeamLead)
                }
                masterData={data.masterData}
                clientData={clientData}
                handleManagerSubmit={handleManagerSubmit}
                isMangerSubmit={isMangerSubmit}
                data={Object.assign(clientData, data)}
                setIsTouched={setIsTouched}
                setBtnDisable={setBtnDisable}
              />
              {auth.role === role.Coder && (
                <div className="d-flex justify-content-start ms-5 mb-6">
                  <button
                    onClick={enabled ? submitChart : () => {}}
                    disabled={btnDisable}
                    type="submit"
                    className="btn fw-bold btn-primary me-2"
                    style={{
                      fontWeight: "bold",
                      backgroundColor: btnDisable ? "gray" : "",
                      marginRight: "0.5rem",
                      cursor: !enabled ? "not-allowed" : "pointer",
                      color: "white",
                    }}
                  >
                    Save
                  </button>
                </div>
              )}
              {false && auth.role === role.Manager && (
                <div className="d-flex justify-content-start ms-5 mb-6">
                  <button
                    onClick={(e) => {
                      submitChart(e);
                      handleManagerSubmit(true);
                    }}
                    type="submit"
                    id="manager_submit"
                    disabled={btnDisable}
                    className="btn fw-bold btn-primary me-2"
                    style={{
                      fontWeight: "bold",
                      backgroundColor: btnDisable ? "gray" : "",
                      marginRight: "0.5rem",
                      cursor: !enabled ? "not-allowed" : "pointer",
                      color: "white",
                    }}
                  >
                    Save
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ChartForm;
